import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from './component/provider/AuthProvider'
import { WalletProvider } from './component/provider/WalletProvider'
import { persister, PersistQueryClientProvider, queryClient } from './config/reactQuery'
import router from './router'

function App() {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      <AuthProvider>
        <WalletProvider>
          <RouterProvider router={router} future={{ v7_startTransition: true }} fallbackElement={<></>} />
        </WalletProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  )
}

export default App
